import {
  Toaster as Sonner,
  type ToasterProps,
  toast as sonnerToast,
} from "sonner";

import { cn } from "@/lib/utils";

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className={cn("wl-toast", props.className)}
      closeButton={true}
      duration={5000}
      toastOptions={{
        classNames: {
          info: "wl-toast-info",
          warning: "wl-toast-warning",
          success: "wl-toast-success",
          error: "wl-toast-error",
        },
      }}
      {...props}
    />
  );
};

// Custom toast functions that target the toast component
export const toast = {
  show: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast(title, {
      ...options,
      toasterId: "toast-sooner",
      className: `wl-toast-item${options?.className || ""}`,
      id: `toast-${Date.now()}-${Math.random()}`,
    });
  },
  success: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.success(title, {
      ...options,
      toasterId: "toast-sooner",
      className: `wl-toast-item${options?.className || ""}`,
      id: `toast-success-${Date.now()}-${Math.random()}`,
    });
  },
  error: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.error(title, {
      ...options,
      toasterId: "toast-sooner",
      className: `wl-toast-item${options?.className || ""}`,
      id: `toast-error-${Date.now()}-${Math.random()}`,
    });
  },
  warning: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.warning(title, {
      ...options,
      toasterId: "toast-sooner",
      className: `wl-toast-item${options?.className || ""}`,
      id: `toast-warning-${Date.now()}-${Math.random()}`,
    });
  },
  info: (title: string, options?: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.info(title, {
      ...options,
      toasterId: "toast-sooner",
      className: `wl-toast-item${options?.className || ""}`,
      id: `toast-info-${Date.now()}-${Math.random()}`,
    });
  },
  promise: (promise: Promise<any>, options: any) => {
    // Dismiss existing snackbars before showing new one
    sonnerToast.dismiss();
    return sonnerToast.promise(promise, {
      ...options,
      toasterId: "toast-sooner",
      className: `wl-toast-item${options?.className || ""}`,
      id: `toast-promise-${Date.now()}-${Math.random()}`,
    });
  },
  dismiss: (id?: string | number) => {
    return sonnerToast.dismiss(id);
  },
};

export { Toaster };
